module.exports = __webpack_public_path__ + "static/media/sumimoto-mobiles-tiny.b0b04d0e.jpg";